module.exports = __webpack_public_path__ + "static/media/080-iceland.5b55a936.svg";